module.exports = __webpack_public_path__ + "static/media/air_courier_transporters.a09a3189.xlsx";